import { Checkbox as AntdCheckbox } from 'antd';
import styled from 'styled-components';

const Checkbox = styled(AntdCheckbox)`
  align-items: center;
  padding: 3px;

  & > .ant-checkbox {
    top: 0;

    & > .ant-checkbox-inner {
      width: 18px;
      height: 18px;
      border-radius: 4px;
    }
  }

  & > .ant-checkbox-checked::after {
    border-radius: 4px;
  }

  & > span:nth-child(2) {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
`;

export default Checkbox;
